module.exports = __webpack_public_path__ + "static/media/FluxRoom2.121b493e.jpg";